import { Component } from '@/node_modules/nuxt-property-decorator'
import { BaseVue, NuxtAppContext } from './BaseVue'

@Component
export class PageComponentVue extends BaseVue {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncData(this: void, context: NuxtAppContext | null): void {}
}
